import { gql } from "lib/apolloClient";
import { aiFragment, attachmentFragment } from "modules/CommonFragments";
import {
  attachmentWithModalityFragment,
  modalitiesFragments,
} from "./AIChatFragments";

export const createAIModalityAttachmentMutation = gql`
  mutation createAIModalityAttachment($input: [AttachmentInput!]) {
    platform {
      createAttachment(input: $input) {
        ...attachmentWithModalityItem
      }
    }
  }
  ${attachmentWithModalityFragment}
`;

export const createAITutorModalityMutation = gql`
  mutation createAITutorModality($input: AttachmentInput!) {
    platform {
      createAiTutorModality(input: $input) {
        id
        name
        type
        mimeType
        url
        signedUrl
        thumbUrl
        title
        metadata
        streamUrl
        parentType
        isRead
        createdBy {
          id
          type
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;

export const updateAiMessageMutation = gql`
  mutation updateAiMessage($input: UpdateAiMessageInput!) {
    ai {
      updateAiMessage(input: $input) {
        isSuccess
        response {
          conversation {
            id
            messages {
              totalCount
              pageInfo {
                hasNextPage
                endCursor
              }
              edges {
                node {
                  ...aiMessageItem
                }
              }
            }
          }
        }
      }
    }
  }
  ${aiFragment.aiMessage}
`;

export const deleteJobMutation = gql`
  mutation integrationDeleteJob($input: IntegrationDeleteJobInput!) {
    integration {
      integrationDeleteJob(input: $input)
    }
  }
`;

export const updateAITutorModalityMutation = gql`
  mutation updateAITutorModality($input: AiTutorModalityUpdateInput!) {
    platform {
      updateAiTutorModality(input: $input) {
        isSuccess
        warning
        attachment {
          ...attachmentWithModalityItem
        }
      }
    }
  }
  ${attachmentWithModalityFragment}
`;

export const deleteAIMessageMutation = gql`
  mutation deleteAiMessage($input: DeleteAiMessageInput!) {
    ai {
      deleteAiMessage(input: $input) {
        isSuccess
        warning
      }
    }
  }
`;

export const updateAttachmentMutation = gql`
  mutation updateAttachment(
    $input: AttachmentUpdateInput!
    $skipModalityAttachment: Boolean = false
  ) {
    platform {
      updateAttachment(input: $input) {
        ...attachmentItem
        modalityAttachment @skip(if: $skipModalityAttachment) {
          ...modalityAttachmentItem
        }
      }
    }
  }
  ${attachmentFragment.attachment}
  ${modalitiesFragments.modalityAttachment}
`;

export const updateAIMessageMutation = gql`
  mutation updateAITutorMessage($input: UpdateAiMessageInput!) {
    ai {
      updateAiMessage(input: $input) {
        isSuccess
        response {
          conversation {
            id
            messages {
              totalCount
              pageInfo {
                hasNextPage
                endCursor
              }
              edges {
                node {
                  ...aiMessageItem
                  attachments {
                    ...attachmentWithModalityItem
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${aiFragment.aiMessage}
  ${attachmentWithModalityFragment}
`;
